import { render, staticRenderFns } from "./ResourceComponent.vue?vue&type=template&id=5eb639af&scoped=true"
import script from "./ResourceComponent.vue?vue&type=script&lang=js"
export * from "./ResourceComponent.vue?vue&type=script&lang=js"
import style0 from "./ResourceComponent.vue?vue&type=style&index=0&id=5eb639af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb639af",
  null
  
)

export default component.exports